import { useState, useEffect } from "react";
import CloseIcon from "../assets/crossIcon.svg";
const RpaAttempts = ({ attempts, setOpen }) => {
  return (
    <div className="fixed top-0 left-0 h-screen w-screen bg-[#017C5780] flex justify-center items-center z-[1201] ">
      <div className="relative w-[60%] h-[50%] bg-white rounded-[20px] p-10">
        <div
          className="absolute top-4 right-5 cursor-pointer"
          onClick={() => setOpen(null)}
        >
          <img src={CloseIcon} alt="close-icon" />
        </div>
        <div className="text-xl font-semibold">RPA Attempts Report</div>
        <div className="h-[90%] mt-3 overflow-y-auto">
          {attempts?.map((attempt, idx) => {
            return <div key={idx}>{idx}</div>;
          })}
        </div>
      </div>
    </div>
  );
};

export default RpaAttempts;
